import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "bg-base rounded-full",
  viewBox: "0 0 128 128"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M31.397 34.267C29.87 41.999 33.238 49 33.238 49s5.84-5.535 7.365-13.267S38.762 21 38.762 21s-5.84 5.535-7.366 13.267",
      opacity: ".2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D0CDE1",
      d: "M56.5 70C71.688 70 84 57.688 84 42.5S71.688 15 56.5 15 29 27.312 29 42.5 41.312 70 56.5 70"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D0CDE1",
      d: "M47 63.857s3.217 14.929 3.217 16.5C50.217 81.93 65.5 89 65.5 89l13.674-2.357L84 72.5S75.957 60.714 75.957 56z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2F2E41",
      d: "m120 83.372-.216.524c-5.88 14.087-16.076 25.691-28.957 32.956s-27.703 9.771-42.096 7.118a62.16 62.16 0 0 1-14.812-4.705 64.358 64.358 0 0 1-11.905-7.15L19 102.91l1.694-1.361 3.484-2.802 3.717-2.988.967-.778 14.586-11.727 1.077-.865L50 78l.5 1s9.807 11.36 21.724 7.178C84.141 81.995 83.5 72 83.5 72zM35.018 20.248s8.125-18.97 23.698-14.592C74.288 10.034 83.09 16.6 83.767 23.166s-.338 16.417-.338 16.417-1.693-13.498-12.526-10.58c-10.833 2.92-27.76.73-27.76.73L40.435 56s-4.05-4.419-7.435-1.5-8.815-28.415 2.018-34.252"
    }, null, -1)
  ]))]))
}
export default { render: render }